// Presentation is separate from catalog status and permission to accept payment.
export const PUBLIC_BROWSING = typeof document !== 'undefined' && document.body.classList.contains('gbm-public-browsing');
